<template>
  <div class="container_none">
    <ul class="list">
      <li>友邻少年家庭卡是专为无限卡会员家人开放的福利卡。所以需要无限卡会员提供相关证明，敬请理解。</li>
      <li>
        北京每日友邻文化科技有限公司（以下简称“友邻少年”）承诺对用户提供的所有个人信息会进行保密，不会出现泄漏给第三方信息等安全问题。
      </li>
      <li>本次活动仅支持无限卡会员为家庭成员中的配偶或子女购买并使用。其他家庭成员若想购买请关注活动消息。</li>
      <li>
        请您仔细阅读以下购买说明，并填写提交相关内容：
        <div>
          本人为友邻少年无限卡会员 ID：
          <span>{{ appUser.userId }}</span>
          ，绑定手机号为：
          <span>{{ appUser.mobileNumber }}</span>
          申请购买家庭卡账号。
        </div>
      </li>
      <li>本人已知晓并认可，购买的家庭账号属于本人无限卡账号的子账号。</li>
      <li class="sub_padding_box">本人已知晓并认可，子账号除听课权益外，暂无其他权益。</li>
      <li class="sub_padding_box">本人已知晓并认可，子账号听课权益跟随无限卡账号听课权益保持一致。</li>
      <li class="sub_padding_box">本人已知晓并认可，无限卡账号权益出现暂停、关闭等情况，子账号与其保持一致 。</li>
      <li class="sub_padding_box">本人已知晓并认可，子账号无法对账号进行任何信息修改操作，只能由主账号操作或申请 。</li>
      <li class="sub_padding_box">
        本人自愿出具本人身份证正面、配偶/子女身份证反面、双方关系证明（户口本或结婚证）来证明双方属于家庭成员关系，并自愿授权友邻可以核查信息真实性。
      </li>
      <li>
        本人承诺出具的相关证明真实有效。一旦发现提供证明为虚假信息，友邻少年有权关闭本人无限卡账号及子账号，不再提供服务。
      </li>
    </ul>
  </div>
</template>

<script>
import { appUser } from '@/utils'
export default {
  props: {},
  data() {
    return {
      appUser
    }
  },
  created() {
    console.log('appUser', appUser)
  },

  methods: {}
}
</script>

<style lang="less" scoped>
.container_none {
  font-size: 0.24rem;
  font-weight: 400;
  color: #333333;
  line-height: 0.36rem;
  .title {
    span {
      font-size: 0.24rem;
      font-weight: 500;
      color: #333333;
    }
  }
  .list {
    li {
      margin-top: 0.32rem;
      span {
        text-decoration: underline;
      }
    }
    .sub_padding_box {
      margin-top: 0.12rem;
    }
  }
}
</style>
